import { FileText } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <FileText className="w-12 h-12 text-primary-500 mx-auto mb-4" />
          <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Terms of Use
          </h1>
          <p className="text-lg text-gray-600">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        </div>

        <div className="prose prose-lg max-w-none">
          <p>
            Welcome to Egg Time On. By accessing and using our website, you accept and agree to be bound by the following terms and conditions. Please read these terms carefully before using our service.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing or using Egg Time On, you agree to be bound by these Terms of Use and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">2. Use License</h2>
          <p>
            Permission is granted to temporarily access the materials on Egg Time On for personal, non-commercial use only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to reverse engineer any software contained on Egg Time On</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
          </ul>
          <p>
            This license shall automatically terminate if you violate any of these restrictions and may be terminated by Egg Time On at any time.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">3. Disclaimer</h2>
          <p>
            The materials on Egg Time On are provided on an 'as is' basis. Egg Time On makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property</li>
            <li>Implied warranties or conditions arising from course of dealing or course of performance</li>
            <li>Accuracy, reliability, or availability of the website or its contents</li>
          </ul>
          <p>
            Furthermore, Egg Time On does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">4. Limitations</h2>
          <p>
            In no event shall Egg Time On or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Egg Time On, even if Egg Time On or an authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>
          <p>
            Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">5. Accuracy of Materials</h2>
          <p>
            The materials appearing on Egg Time On could include technical, typographical, or photographic errors. Egg Time On does not warrant that any of the materials on its website are accurate, complete, or current. Egg Time On may make changes to the materials contained on its website at any time without notice.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">6. Links</h2>
          <p>
            Egg Time On has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Egg Time On of the site. Use of any such linked website is at the user's own risk.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">7. Modifications</h2>
          <p>
            Egg Time On may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the current version of these terms of service.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">8. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">9. Amazon Affiliate Disclosure</h2>
          <p>
            Egg Time On is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com.
          </p>
          <p>
            As an Amazon Associate, we earn from qualifying purchases. This means that when you click on Amazon links on our website and make a purchase, we may earn a commission at no additional cost to you.
          </p>

          <h2 className="font-display text-2xl font-semibold mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about these Terms of Use, please contact us:
          </p>
          <ul className="list-disc pl-6 mb-4">
          <li>By visiting our contact page: <a href="/contact" className="text-primary-600 hover:text-primary-700">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;